import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { AgentProfileDto, AgentType } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-network-display',
  imports: [MatIconModule, RouterModule],
  templateUrl: './agent-network-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentNetworkDisplayComponent {
  readonly profile = input<AgentProfileDto | null | undefined>(undefined);
  readonly agentType = input<AgentType>('titulaire');
  readonly network = input<string | undefined>(undefined);
  readonly showLinkToAgentPage = input<boolean>(true);

  resolvedType(): AgentType {
    return this.profile()?.type ?? this.agentType();
  }

  resolvedNetwork(): string | undefined {
    return this.profile()?.activity?.network ?? this.network();
  }
}
